var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state.loading)?_c('NbSpinner',{staticClass:"mt-4",attrs:{"align":"center","size":"2.1rem"}}):_c('TotalOrdersChart',{staticStyle:{"height":"500px"},attrs:{"values":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }